import React from 'react'
import { Button, ButtonProps } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { TOptions } from 'i18next'

type Props = {
  translationKey: string
  defaultText?: string
  titleKey?: string
  tOptions?: TOptions
  children?: (text: string) => React.ReactElement
  icon?: React.ReactElement
} & ButtonProps

export const LocalizedButton = (props: Props) => {
  const {
    translationKey,
    defaultText,
    tOptions,
    titleKey,
    children,
    icon,
    ...buttonProps
  } = props

  const { t } = useTranslation(translationKey.split(':')[0])

  const translatedText = t(translationKey, tOptions || defaultText)

  return (
    <Button
      style={{ alignItems: 'flex-start' }}
      {...buttonProps}
      title={t(titleKey)}
    >
      {props.icon && <span style={{ marginRight: '.5em' }}>{icon}</span>}
      {props.children ? (
        <span>{children(translatedText)}</span>
      ) : (
        <span>{translatedText}</span>
      )}
    </Button>
  )
}
